import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import subscribeToChannel from './subscribe'
import { recentPracticeStorage, practiceStorage } from '../services/localStorage'


const createSocketCbs = component => ({
  connected() {
    console.log('connected')
    component.setState({ isConnected: true })
  },

  disconnected() {
    console.log('disconnected')
    component.setState({ isConnected: false })
  },

  rejected() {
    console.log('rejected')
    component.setState({ isConnected: false })
  },

  received(message) {
    console.log('received')
    const {
      channelName,
      toggleLoading,
      toggleRecentsLoading,
    } = component.props

    switch (channelName) {
      case 'DashboardChannel': {
        const { data, recents } = message
        const mappedData = data.map(practice => JSON.parse(practice))
        if (recents) {
          recentPracticeStorage.clear()
          recentPracticeStorage.set(JSON.stringify(mappedData))
          toggleRecentsLoading(false)
        } else {
          practiceStorage.clear()
          practiceStorage.set(JSON.stringify(mappedData))
          toggleLoading(false)
        }
        break
      }
      default: {
        console.log('unknown message received')
      }
    }
  },
})

class Socket extends Component {
  static propTypes = {
    debug: PropTypes.bool,
    channelName: PropTypes.string.isRequired,
  }

  constructor(props) {
    super(props)
    this.state = {
      isConnected: false,
      message: null,
    }

    // socket connections on instance
    this._consumer = null
  }

  componentDidMount() {
    const { debug, channelName } = this.props
    this._consumer = subscribeToChannel(channelName, createSocketCbs(this))
    if (debug) {
      window[`_consumer_${channelName}`] = this._consumer
    }
  }

  componentWillUnmount() {
    this._consumer.disconnected()
  }

  render() {
    return <div className="Socket" />
  }
}


export default withRouter(Socket)



// WEBPACK FOOTER //
// ./src/Socket/index.js